import { PaginationInfo, ValidatorResponse } from "src/model"
import imageCompression from 'browser-image-compression';

const inputValidator = (data: any, exemptedPropertes?: string[]): ValidatorResponse => {
    var result = <ValidatorResponse>{ isValidated: true }
    for (let key in data) {
        if (!data[key] && !exemptedPropertes?.includes(key)) {
            result.isValidated = false;
            result.message = `Input: Kindly provide ${key}`
            break;
        }
    }
    console.log({result})
    return result 
} 

const validateEmail = (email: string): boolean => {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
}

const searchTableData = (tableData: any, searchText: string) => {
    let result = []

    for (let obj of tableData) {
        for (let key in obj) {
            if (String(obj[key]).toLowerCase().includes(searchText.toLowerCase())) {
                result.push(obj)
                break;
            }
        }
    }

    if (result.length < 1) {
        result = tableData
    }

    return result
}

const addSerialNumberToItems = (data: any, paginationInfo: PaginationInfo, shouldPullData = false, pullDataKey?: string) => {
    let result = []
    const {pageNumber = 1, pageSize = 10} = paginationInfo
    let index = ((pageNumber - 1) * pageSize) + 1
    
    for (let item of data) {
        if (shouldPullData && pullDataKey) {
            item = {...item, ...item[pullDataKey]}
        }
        item.sn = index
        result.push(item)
        index++
    }

    return result
}

const addSerialNumberNonPagination = (data: any) => {
    let result = []
    let index = 1

    for (let item of data) {
        item.sn = index
        result.push(item)
        index++
    }

    return result
}

const getInputValidDate = () => {
    let dtToday = new Date()

    let [month, day, year]: Array<any> =  [
        dtToday.getMonth() + 1,
        dtToday.getDate(),
        dtToday.getFullYear()
    ]

    if (month < 10) month = `0${month}`
    if (day < 10) day = `0${day}`

    return `${year}-${month}-${day}`
}

const isValidFileType = (filename: string) => {
    let result = true
    let splittedFileName = filename.split('.')
    let extension = splittedFileName[splittedFileName.length - 1].toLowerCase()
    if (!['svg', 'png', 'jpg', 'jpeg'].includes(extension)) result = false
        return result
}

const getFileExtension = (file: string) => {
    const splittedFileName = file.split('.')
    let extension = splittedFileName[splittedFileName.length - 1].toLowerCase()

    return extension === 'svg' ? 'png' : extension
}

export const compressImage = async (image: any, maxSizeMB = 0.39) => {
    const file = image //e.target.files[0];

    try {
        const options = {
            maxSizeMB,
            //maxWidthOrHeight: 800,
            useWebWorker: true,
        };

        const compressedFile = await imageCompression(file, options);

        console.log({compressedFile})

        return compressedFile
    } catch (err: any) {
        console.error('Error compressing image:', err.message);
        return ''
    }
};

const convertFileToBase64 = (file: any, returnContentType = false) => {
    return new Promise(resolve => {
        let fileInfo;
        let baseURL: any = "";
        let contentType: string = ""
        let reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => {
            baseURL = reader.result;
            contentType = baseURL.split(':')
            contentType = contentType[1].split(';')[0]
            baseURL = baseURL.replace('data:image/png;base64,', '').replace('data:image/jpeg;base64,', '').replace('data:image/jpg;base64,', '')
            resolve(returnContentType ? {baseURL, contentType} : baseURL);
        };
    });
};

const splitDateTime = (data: string) => {
    let [date, time] = data.split('T')
    let [year, month, day] = date.split('-')
    let [hours, minutes] = time.split(':')

    month = (month.length > 1 && month[0] === '0') ? month[1] : month
    const monthShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    const formattedHours = (hours.length > 1 && hours[0] === '0') ? hours[1] : hours

    return {
        date: `${day}-${monthShort[Number(month)-1]}-${year}`,
        slashedDate: `${day}/${month}/${year}`,
        time: `${hours}:${minutes}`,
        timeEnv: `${Number(formattedHours) < 12 ? 'am' : 'pm'}`,
        completeTime: `${hours}:${minutes}${Number(formattedHours) < 12 ? 'am' : 'pm'}`,
        completeDateTime: `${day}/${month}/${year} ${hours}:${minutes}${Number(formattedHours) < 12 ? 'am' : 'pm'}`
    }

}

const handleDate = (date: string) => {
    if (!date) return false;
    
    let formattedDate = splitDateTime(date);
    return `${formattedDate?.date} ${formattedDate?.time}${formattedDate?.timeEnv}`
}

const getStartAndEndDate = (period: string) => {
    const [durationNumber, durationPeriod] = period.split(' ')

    let startDate = new Date();
    let endDate = new Date();

    if (durationPeriod === 'months') {
        startDate.setMonth(endDate.getMonth() - Number(durationNumber));
    }
    else if (durationPeriod === 'days') {
        startDate.setDate(endDate.getDate() - Number(durationNumber));
    }
    else if (durationPeriod === 'hours') {
        startDate = new Date(endDate.getTime() - Number(durationNumber) * 60 * 60 * 1000);
    }

    const formatDate = (date: Date) => date.toISOString().split('T')[0];

    return {
        fromDate: formatDate(startDate),
        toDate: formatDate(endDate)
    }
}

const formatCardNumber = (cardNumber: string) => {
    return cardNumber.trim().replace(/(\d{4})(?=\d)/g, '$1 ');
};

const isMastercard = (cardNumber: string) => {
    cardNumber = cardNumber.replace(/ /g, '')
    //console.log({cardNumber})

     // Remove non-digit characters
    const sanitizedNumber = cardNumber.replace(/\D/g, '');
    
    // Check if it starts with Mastercard ranges
    const mastercardRegex = /^(5[1-5]\d{14}|222[1-9]\d{12}|22[3-9]\d{13}|2[3-6]\d{14}|27[01]\d{13}|2720\d{12})$/;
    return mastercardRegex.test(sanitizedNumber);
};

const wait = (time: number) => new Promise(res => setTimeout(res, time))

export default {
    inputValidator,
    validateEmail,
    searchTableData,
    addSerialNumberToItems,
    addSerialNumberNonPagination,
    getInputValidDate,
    isValidFileType,
    getFileExtension,
    compressImage,
    convertFileToBase64,
    splitDateTime,
    handleDate,
    getStartAndEndDate,
    formatCardNumber,
    isMastercard,
    wait
}
